import { SanitizeHtml } from '@main/pc-core-components';
import type { AssetFile } from '@main/pc-types';
import { createAsset, privacyCenterCustomizableMessages } from '@main/pc-types';
import { ASSET_BASE_URL } from '@main/utils';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectDisabledPrivacyCenterAboutTranscend } from '../../containers/App/selectors';
import { heroMessages } from './messages';
import {
  AboutTranscendWrapper,
  AssetWrapper,
  DescriptionWrapper,
  HeroWrapper,
  TextWrapper,
  TitleWrapper,
} from './wrappers';

/**
 * The Hero props
 */
export interface HeroProps {
  /** The hero asset (image or video), currently a url */
  asset?: AssetFile;
  /** The link to page detailing how Transcend works */
  aboutTranscendUri?: string;
}

/**
 * The Page Hero
 */
function Hero({
  aboutTranscendUri = '/about',
  asset = createAsset(`${ASSET_BASE_URL}/hero-default.svg`, {
    mimetype: 'image/svg',
  }),
}: HeroProps): JSX.Element {
  const { formatMessage } = useIntl();
  const disabledPrivacyCenterAboutTranscend = useSelector(
    selectDisabledPrivacyCenterAboutTranscend,
  );

  // TODO handle videos
  if (!asset.mimetype || !asset.mimetype.startsWith('image/')) {
    throw new Error('Hero only supports images -- TODO');
  }

  return (
    <HeroWrapper>
      <TextWrapper>
        <TitleWrapper>
          {formatMessage(privacyCenterCustomizableMessages.heroTitle)}
        </TitleWrapper>
        <DescriptionWrapper>
          <SanitizeHtml
            html={formatMessage(
              privacyCenterCustomizableMessages.heroDescription,
            )}
          />
        </DescriptionWrapper>
        {!disabledPrivacyCenterAboutTranscend && (
          <AboutTranscendWrapper
            message={heroMessages.aboutTranscend}
            values={{
              privacyCenter: formatMessage(
                privacyCenterCustomizableMessages.privacyCenterTitle,
              ),
            }}
            href={aboutTranscendUri}
          />
        )}
      </TextWrapper>
      <AssetWrapper
        src={asset.src}
        alt={formatMessage(asset.alt || heroMessages.assetAlt)}
      />
    </HeroWrapper>
  );
}

export default Hero;
